'use client';

import { useSearchParams } from 'next/navigation';

import { Text } from '@backyard-ui/core';

import { useGlobalStore } from '@/presenters/store/global';
import {
  REGION,
  REGION_ID,
  STORE,
  STORE_CODE,
} from '@/utils/constants/queries';

export default function RegionName() {
  const searchParams = useSearchParams();

  const hasAnyRegionParam =
    searchParams.has(REGION) ||
    searchParams.has(REGION_ID) ||
    searchParams.has(STORE) ||
    searchParams.has(STORE_CODE);

  const regionName = useGlobalStore((state) => state.session?.regionName);
  const shouldRenderRegionName = hasAnyRegionParam && regionName;

  if (!shouldRenderRegionName) {
    return null;
  }

  return (
    <Text size="md" asChild>
      <span>
        - <strong>{regionName}</strong>
      </span>
    </Text>
  );
}
